import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { TTournamentParams } from '~/../api/common.types';
import BattleMatchupsList from '~/components/war/battle/BattleMatchupsList';
import BattleResultsList from '~/components/war/battle/BattleResultsList';
import Layout from '~/components/war/Layout';
import { TOURNAMENTS } from '~/constants';
import { ConnectedProvidersGame } from '~/contextProviders/connectedProviders';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import { useGetContexts } from '~/hooks/game/useGetContexts';

const BattlePage = () => {
  const { byesByOwner, ownerPairings, isAttacksActive } = useGameContext();
  const { accessToken } = useGameAuthentication();

  if (!accessToken) {
    return (
      <Layout>
        <div className="war__container">
          <div className="battle-matchups--loading"></div>
        </div>
      </Layout>
    );
  }

  if (
    ownerPairings &&
    !ownerPairings?.length &&
    byesByOwner &&
    !byesByOwner.length
  ) {
    return (
      <Layout>
        <div className="war__container">
          <div className="battle-matchups--loading">
            You have no matchups this round
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {isAttacksActive ?
        <BattleMatchupsList /> :
        ownerPairings ?
          <BattleResultsList ownerPairings={ownerPairings} /> :
          <div className="battle-matchups--loading">Loading...</div>
      }
    </Layout>
  );
};
// const STATE_NOT_READY = 8;
const TournamentsBattle = () => {
  const router = useRouter();
  const [tournamentParam, setTournamentParam] = useState('');

  const { data: contexts } = useGetContexts({
    enabled: !!tournamentParam,
  });

  useEffect(() => {
    if (!router.isReady) return;
    const tournamentParameter = router?.query?.tournaments as string;
    const tournamentIDs = Object.keys(TOURNAMENTS);
    if (!tournamentIDs.includes(tournamentParameter)) {
      router.push('/404');
    }
    setTournamentParam(tournamentParameter);
  }, [router, router.isReady, router?.query?.tournaments]);

  if (!contexts || !tournamentParam) {
    return <></>;
  }
  const totalStates = contexts.context_states.filter(
    (cont) =>
      cont.context_id === TOURNAMENTS[tournamentParam].apiContext &&
      cont.state !== null
      // cont.state < STATE_NOT_READY
  );
  if (!totalStates.length) {
    router.push('/404');
    return <></>;
  }


  const context = totalStates
    .filter((context) => context.state !== undefined)
    .reduce((prev, current) => {
      if (prev.state === null || current.state === null) {
        // typescript complaint
        return prev;
      }
      return prev.state > current.state ? prev : current;
    });

  const battleId = context.state as number;

  return (
    <ConnectedProvidersGame
      battleId={battleId}
      tournamentParam={tournamentParam as TTournamentParams}
      totalStates={totalStates}
    >
      <BattlePage />
    </ConnectedProvidersGame>
  );
};

export default TournamentsBattle;
